import React from "react";

export default function () {
    return <span className="Polaris-Navigation__Item-Badge--new">New!</span>;
}
